import { SET_EMAIL } from './../Action/action'

const defaultState = {
    currentUser: {}
}

function reducer(state = defaultState, action){
    switch(action.type) {
        case "SET_USER":
            return {
                ...state,
                currentUser: action.payload
            }
        case SET_EMAIL:
            return {
                ...state,
                currentEmail: action.payload
            }
        default: return state
    }
}

export default reducer